/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { debounce } from 'utils/debounce';

  const __vue_script__ = {
    name: "range",
    props:{

      /**
       * ID value for label.
       */
      id: {
        // type: String,
        default: undefined,
      },

      /**
       * @TODO find out what changes from the `unit` props
       */
      label: {
        type:    String,
        default: ''
      },

      /**
       * Min range slider value.
       */
      min: {
        type:    Number,
        default: 0
      },

      /**
       * Max range slider value.
       */
      max: {
        type:    Number,
        default: 10
      },

      /**
       * Range slider step.
       */
      step: {
        type:    Number,
        default: 1
      },

      /**
       * @TODO appears to be unused, if so please remove.
       */
      labelValue: {},

      /**
       * Current range value.
       */
      value: {
        default: 0
      },

      /**
       * Whether to emit the `changed` event.
       */
      sync: {
        type:    Boolean,
        default: false
      },

      /**
       * Whether display current range value.
       */
      showValue: {
        type:    Boolean,
        default: false
      },

      /**
       * Range unit.
       */
      unit: {
        type:    String,
        default: ''
      }

    },
    data() {
      return {
        state: { value: this.value }
      };
    },
    methods: {
      changeBackGround(value) {
        this.$refs['range-input'].style.backgroundSize = `${value ? (value - this.min) * 100 / (this.max - this.min): 0}% 100%`;
      },
      setValue(value) {
        this.changedValue(value);
      },
      change(e) {
        this.changedValue(1*e.target.value);
      },
      emitChangeValue(value) {
        this.state.value = value;
        this.$emit('change-range', {
          id: this.id,
          value
        });
      }
    },
    watch: {
      /**@since 3.8.0 need to watch changes of prop value and reflect it to state.value*/
      'value'(value) {
        this.state.value = value;
      },
      'state.value'(value) {
        this.changeBackGround(value);
        if (this.sync) { this.emitChangeValue(value) }
      }
    },
    created() {
      this.changedValue =  this.sync ? () => this.$emit('changed') : debounce(value => {
        this.emitChangeValue(value)
      })
    },
    async mounted() {
      await this.$nextTick();
      this.changeBackGround(this.value);
    },
  }

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticStyle:{"display":"flex","justify-content":"space-between","font-weight":"bold"}},[_c('section',{staticStyle:{"align-self":"flex-end"}},[_c('span',{staticClass:"min-max-label"},[_vm._v(_vm._s(_vm.min))]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.unit))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin":"0 3px"}},[_c('label',{directives:[{name:"t",rawName:"v-t",value:(_vm.label),expression:"label"}],staticClass:"skin-color",staticStyle:{"display":"block"},attrs:{"for":_vm.id}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],ref:"range-input",attrs:{"type":"range","id":_vm.id,"min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":(_vm.state.value)},on:{"change":_vm.change,"__r":function($event){return _vm.$set(_vm.state, "value", $event.target.value)}}})]),_vm._v(" "),_c('section',{staticStyle:{"align-self":"flex-end"}},[_c('span',{staticClass:"min-max-label"},[_vm._v(_vm._s(_vm.max))]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.unit))])])]),_vm._v(" "),(_vm.showValue)?[_c('span',[_vm._v(_vm._s(_vm.state.value))]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.unit))])]:_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-efe7be7e_0", { source: ".min-max-label[data-v-efe7be7e]{align-self:end;font-weight:700}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-efe7be7e"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "GlobalRange.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__